import { z } from "zod";

export const simpleQuestionSchema = z.object({
  id: z.string(),
  type: z.literal("simple"),
  content: z.string(),
  isEdit: z.boolean(),
  perfectScore: z.coerce.number().min(1, "Perfect score must be at least 1."),
});

export type SimpleQuestion = z.infer<typeof simpleQuestionSchema>;
